import QRCode from "qrcode";

function taiAnh(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

// Vẽ QR + mã chữ (dự phòng khi máy quét không đọc được, hoặc QR bị mờ/rách
// lúc in) ngay bên dưới lên 1 canvas, xuất ra 1 ảnh PNG duy nhất — thay vì
// chỉ có QR trần như QRCode.toDataURL() gốc. Dùng cho mọi chỗ tải/xuất QR
// (nút tải 1 mã, xuất ZIP hàng loạt) để nhất quán.
export async function taoAnhQrKemMa(value, px) {
  const anhQr = await taiAnh(await QRCode.toDataURL(value, { width: px, margin: 1 }));

  const caoChu = Math.max(Math.round(px * 0.14), 24);
  const canvas = document.createElement("canvas");
  canvas.width = px;
  canvas.height = px + caoChu;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(anhQr, 0, 0, px, px);

  ctx.fillStyle = "#000";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  let coFont = Math.round(caoChu * 0.55);
  const rongToiDa = px * 0.94;
  ctx.font = `bold ${coFont}px Arial, sans-serif`;
  while (coFont > 8 && ctx.measureText(value).width > rongToiDa) {
    coFont -= 1;
    ctx.font = `bold ${coFont}px Arial, sans-serif`;
  }
  ctx.fillText(value, px / 2, px + caoChu / 2);

  return canvas.toDataURL("image/png");
}
